// const listaDeUsuarios = (state) => {
//     return state.items || [];
// }

// const loadingUsuario = (state) => {
//     return state.buscando
// }

const listaPerfis = (state) => {
    return state.perfis
}

const usuarioSelecionadoComPerfis = (state) => {
    return state.selecionado
}

const loadingUsuariosPerfis = (state) => {
    return state.buscando
}

export {
    // listaDeUsuarios,
    // loadingUsuario,
    listaPerfis,
    usuarioSelecionadoComPerfis,
    loadingUsuariosPerfis
}